import {
  getTextFromEditorV3,
  IEditorV3,
  isIEditorV3,
  joinV3intoBlock,
  replaceTextInEditorV3,
  splitV3intoLines,
  stringToV3,
} from "@azu-business/editor-v3";
import { EditorDefns } from "aic";
import { EditorV3Wrapper } from "./EditorV3Wrapper";

export const v3EditorProps: EditorDefns<IEditorV3> = {
  Editor: EditorV3Wrapper,
  blankT: stringToV3(""),
  getTextFromT: getTextFromEditorV3,
  isT: isIEditorV3,
  joinTintoBlock: joinV3intoBlock,
  replaceTextInT: replaceTextInEditorV3,
  splitTintoLines: splitV3intoLines,
  textToT: stringToV3,
};
